// export const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}/ibs`;
// export const API_BASE_URL = 'http://localhost:9044';
export const API_BASE_URL =
  window.location.hostname === 'localhost'
    ? 'http://localhost:9044'
    : `${window.location.protocol}//${window.location.hostname}`;

// export const API_BASE_URL= "https://spark.indicrm.io/ibs";
export const SOCKET_BASE_URL = 'https://admin.watconnect.com';

/** WatConnect WhatsApp realtime — separate from Spark API / TeleCMI socket. */
export const WATCONNECT_SOCKET_URL =
  (typeof process !== 'undefined' &&
    process.env.REACT_APP_WATCONNECT_SOCKET_URL &&
    String(process.env.REACT_APP_WATCONNECT_SOCKET_URL).trim()) ||
  SOCKET_BASE_URL;
export const WATCONNECT_SOCKET_PATH =
  (typeof process !== 'undefined' &&
    process.env.REACT_APP_WATCONNECT_SOCKET_PATH &&
    String(process.env.REACT_APP_WATCONNECT_SOCKET_PATH).trim()) ||
  '/ibs/socket.io';

/** Spark CRM API + TeleCMI inbound (ibs-spark-backend server.js: path '/socket.io'). */
export const SOCKET_IO_PATH =
  (typeof process !== 'undefined' && process.env.REACT_APP_SOCKET_PATH) ||
  '/socket.io';
//export const SOCKET_IO_URL = 'http://localhost:9022';
export const FILE_UPLOAD_URL = 'http://localhost:3000/public';
export const Watconnect_API_BASE_URL = 'https://admin.watconnect.com/ibs';
export const FRONTEND_URL = `${window.location.protocol}//${window.location.hostname}`;
export const VIEW_LEAD = 'VIEW_LEAD';
export const VIEW_PROPERTY = 'VIEW_PROPERTY';
export const EDIT_LEAD = 'EDIT_LEAD';
export const DELETE_LEAD = 'DELETE_LEAD';
export const VIEW_PRODUCT = 'VIEW_PRODUCT';
export const EDIT_PRODUCT = 'EDIT_PRODUCT';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const MODIFY_ALL = 'MODIFY_ALL';
export const VIEW_ALL = 'VIEW_ALL';
export const VIEW_ORDER = 'VIEW_ORDER';
export const VIEW_USER = 'VIEW_USER';
export const VIEW_CONTACT = 'VIEW_CONTACT';
export const EDIT_CONTACT = 'EDIT_CONTACT';
export const DELETE_CONTACT = 'DELETE_CONTACT';
export const VIEW_ACCOUNT = 'VIEW_ACCOUNT';
export const EDIT_ACCOUNT = 'EDIT_ACCOUNT';
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';
export const VIEW_BUSINESS = 'VIEW_BUSINESS';
export const EDIT_BUSINESS = 'EDIT_BUSINESS';
export const DELETE_BUSINESS = 'DELETE_BUSINESS';
export const VIEW_INCIDENT = 'VIEW_INCIDENT';

//FILE TYPES
export const PDF = 'pdf';
export const DOC = 'doc';
export const DOCX = 'docx';
export const XLS = 'xls';
export const XLSX = 'xlsx';
export const CSV = 'csv';
export const PNG = 'png';
export const JPG = 'jpg';
export const JPEG = 'jpeg';

// export const LEAD_STATUS_VALUES = [{label : 'Open - Not Contacted', islast : false}, {label : 'Working Contacted', islast : false} , {label : 'Closed - Converted', islast : true}, {label : 'Closed - Not Converted', islast : true}];
export const LEAD_STATUS_VALUES = [
  {
    label: 'Open - Not Contacted',
    sortorder: 1,
    is_converted: false,
    is_lost: false,
  },
  {
    label: 'Working - Contacted',
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: 'Closed - Converted',
    sortorder: 3,
    is_converted: true,
    is_lost: false,
  },
  {
    label: 'Closed - Not Converted',
    sortorder: 4,
    is_converted: false,
    is_lost: true,
  },
];
export const Product_CATEGORY_VALUES = [
  {
    label: 'Software',
    sortorder: 1,
    is_converted: false,
    is_lost: false,
  },
  {
    label: 'Hardware',
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: 'Fashion',
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: 'Retail',
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: 'Goods',
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: 'Furniture',
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: 'Stones',
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: 'Policy',
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: 'Others',
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
];

export const Product_SUBCATEGORY_VALUES = [
  {
    label: 'Subscription',
    sortorder: 1,
  },
  {
    label: 'Insurance',
    sortorder: 2,
  },
  {
    label: 'Implementation',
    sortorder: 2,
  },
  {
    label: 'Goods',
    sortorder: 2,
  },
  {
    label: 'Material',
    sortorder: 2,
  },
  {
    label: 'Fashion',
    sortorder: 2,
  },
  {
    label: 'Others',
    sortorder: 2,
  },
];
